var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.G_NAV_SIBLINGS.length)?_c('div',{staticClass:"current-bar pyx mb-16"},_vm._l((_vm.G_NAV_SIBLINGS),function(nav){return _c('router-link',{key:nav.id,class:`depth2 fm-16 ${_vm.G_NAV_ID.startsWith(nav.id) ? 'selected' : ''}`,attrs:{"to":nav.path}},[_vm._v(" "+_vm._s(nav.title)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }